(function( $ ){

    /* javascript code goes here.  Will run after page is loaded in the DOM */


    $('document').ready(function() {


        const $form = $('form');
        const $output = $('#output');
        const $submit = $('[type="submit"]');

        const $inputs = $('[type="text"], [type="url"]');

        $form.on('submit', function(e) {
            e.preventDefault();
            $output.addClass('loading');
            $.post($form.attr('action'), $form.serialize())
                .then(function(response) {
                    if(response.result = 'success') {
                        $output.empty().html(response.data);
                        $('#output-textarea').empty().text(response.data);
                    }
                })
                .always(function() {
                    $output.removeClass('loading');
                })


        })


    });

})(jQuery);
